import React, { useState } from "react";
import "../styles/ClaimChecker.css";

export default function ClaimChecker({onSubmitClaim}) {
  const [claimInput, setClaimInput] = useState("");

  const exampleClaims = [
    {
      text: "Peter Dutton supports First Nation Voice?",
      icon: "🌿",
    },
    {
      text: "Anthony Albanese refuses a tax cut?",
      icon: "💰",
    },
    {
      text: "Ged Kearney wants to tighten vehicle emission standards?",
      icon: "🚗",
    },
    {
      text: "Anthony Albanese want to increase medical funding?",
      icon: "🏥",
    },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (claimInput.trim()) {
      onSubmitClaim(claimInput.trim());
    }
  };

  return (
    <main className="claim-checker-container">
      <section className="claim-checker-inner">
        <header className="header">
          <h1 className="headline">Let AI Fact Check a Political Claim</h1>
          <p className="subtext">Enter a claim involving any Australian politician or parliamentary issue.</p>
        </header>

        <form className="input-group" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Enter a claim about a politician voting or speech records on a particular Issue"
            aria-label="Political claim input"
            value={claimInput}
            onChange={(e) => setClaimInput(e.target.value)}
          />
          <button type="submit">Analyze</button>
        </form>

        <div className="tips">
          💡 <strong>Tips:</strong> Include the elected politician’s full name and the specific claim.
        </div>

        <h2 className="suggestion-label">Can’t think of any topic? Try one of these:</h2>

        <div className="example-claims">
          {exampleClaims.map((claim, index) => (
            <div key={index} className="claim-card">
              <div className="claim-content">
                <span className="icon" aria-hidden="true">{claim.icon}</span>
                <span className="text">{claim.text}</span>
              </div>
              <button className="try-button" type="button" onClick={() => onSubmitClaim(claim.text)}>Try</button>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}